<div class="flex w-full py-3.5 items-center px-6 title font-main text-3xl font-bold text-navy-90 border-b border-navy-30">
  {{ buildTranslationKey('notifications') | translate }}
</div>

<div class="w-full h-full overflow-x-hidden overflow-y-auto pt-4 pb-6 px-6">
  <div class="flex w-full flex-col gap-4 max-w-125">
    <div class="flex w-full flex-col gap-1">
      <div class="text-navy-90 font-bold text-base">
        {{ buildTranslationKey('trustCenterOwners') | translate }}
      </div>

      <div class="text-navy-70 text-base flex flex-col">
        <span class="mb-1">{{ buildTranslationKey('trustCenterOwnersDescription') | translate }}</span>
        <span>{{ buildTranslationKey('newAccessRequests') | translate }}</span>
        <span>{{ buildTranslationKey('ndaCompletion') | translate }}</span>
      </div>

      @if (usersStream$ | async; as users) {
        <app-user-multi-dropdown-control
          class="mt-4"
          [users]="users"
          [currentUserEmail]="currentUserEmail$ | async"
          [ngModel]="currentOwners$ | async"
          (ngModelChange)="updateOwners($event)"
        ></app-user-multi-dropdown-control>
      }
    </div>

    <div class="h-px w-full bg-navy-40"></div>

    <app-slack-notifications-settings></app-slack-notifications-settings>
  </div>
</div>
